console.error(">>>>>> Script is loaded 1");

window.breeze = {
  onCheckoutButtonClick: async (props) => {
    console.error(">>>>>> Script is loaded");
    if (props !== null) {
      try {
        const res = await onProductPage(props);
        return res;
      } catch (e) {
        console.error("Exception: ", e);
      }
    }
    return {
      checkoutFlag: true,
      offerCode: getDiscountCodeFromCookies(),
    };
  },
};

function getDiscountCodeFromCookies() {
  const cookies = document.cookie.split(";");
  const discountCookie = cookies.find((cookie) =>
    cookie.trim().startsWith("discount_code=")
  );
  if (discountCookie) {
    console.error(">>>>>> Discount code found", discountCookie.split("=")[1]);
    return discountCookie.split("=")[1];
  }
  console.error(">>>>>> Discount code not found");
  return null;
}

async function onProductPage(props) {
  try {
    const decodedProps = atob(props);
    const jsonProps = JSON.parse(decodedProps);
    const cartItems = jsonProps !== null ? [jsonProps] : [];
    console.log(">>>>>>>> Cart Items: ", cartItems);
    if (cartItems !== null && cartItems.length > 0) {
      return {
        checkoutFlag: true,
        offerCode: getDiscountCodeFromCookies(),
      };
    }
  } catch (e) {
    console.error("Breeze| Exception| onProductPage: ", e);
  }
  return true;
}

// Ensure the script runs after the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  console.log(">>>>>> DOM fully loaded and parsed");
});
